export type EntityType = 'lessons';

export interface EntityConfig {
  deleteMutation: () => any;
  deleteTitle: string;
  deleteText: string;
}

export const entityConfigs: Record<EntityType, EntityConfig> = {
  lessons: {
    deleteMutation: () => {},
    deleteTitle: 'Delete lessons',
    deleteText: 'Are you sure you want to delete selected lessons?',
  },
};
